import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "registerNumber", "name", "evaluationStatus", "mediaTestMarker",
    "numberingFrom", "numberingTo",
    "row",
    "finalScoreGrade",
    "correctionTotalCount", "notScoredCount", "notEvaluatedCount",
    "notScoredCountParent", "notEvaluatedCountParent",
    "evaluatesButton",
  ];

  static values = {
    isMediaTestMarker: Boolean,
    isCourseSubmissionEndDatePast: Boolean
  }

  connect() {
    this.finalScoreGrade = '';
    this.changeCorrectionStatusCounts();
    this.changeFinalScoreGradeCounts();
    this.listFilter();
    this.disableEvaluatesButton();
  }

  rowTargetConnected(row) {
    if (Object.hasOwn(row.dataset, 'turboStreamed')) {
      this.changeFinalScoreGradeCounts();
      this.disableEvaluatesButton();
    }
  }

  listFilter() {
    let filteredRows = this.filterRegisterNumber(this.rowTargets);
    filteredRows = this.filterName(filteredRows);
    filteredRows = this.filterEvaluationStatus(filteredRows);
    filteredRows = this.filterFinalScoreGrade(filteredRows);
    filteredRows = this.filterMediaTestMarker(filteredRows);
    filteredRows = this.filterNumbering(filteredRows);

    filteredRows.forEach(row => {
      row.hidden = false;
    });

    this.rowTargets.forEach(row => {
      if (!filteredRows.includes(row)) {
        row.hidden = true;
      }
    });
  }

  teacherListFilter() {
    this.listFilter()
    this.changeCorrectionStatusCounts()
  }

  clickFinalScoreGrade(event) {
    const selectedCss = 'count-post-it-label--selected';
    const clickedFinalScoreGrade = event.currentTarget;

    this.finalScoreGrade = clickedFinalScoreGrade.classList.contains(selectedCss) ? '' : clickedFinalScoreGrade.dataset.finalScoreGrade;
    this.finalScoreGradeTargets.forEach(finalScoreGrade => {
      finalScoreGrade !== clickedFinalScoreGrade ?
        finalScoreGrade.classList.remove(selectedCss) :
        clickedFinalScoreGrade.classList.toggle(selectedCss);
    });

    this.listFilter();
  }

  filterRegisterNumber(rowTargets) {
    if (this.registerNumberTarget.value === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => row.dataset.registerNumber.startsWith(this.registerNumberTarget.value))
  }

  filterName(rowTargets) {
    if (this.nameTarget.value === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => row.dataset.name.includes(this.nameTarget.value))
  }

  filterEvaluationStatus(rowTargets) {
    if (this.evaluationStatusTarget.value === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => row.dataset.evaluationStatus === this.evaluationStatusTarget.value)
  }

  filterFinalScoreGrade(rowTargets) {
    if (this.finalScoreGrade === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => row.dataset.finalScoreGrade === this.finalScoreGrade)
  }

  filterMediaTestMarker(rowTargets) {
    if (this.mediaTestMarkerTarget.value === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => row.dataset.teacher === this.mediaTestMarkerTarget.value)
  }

  filterNumbering(rowTargets) {
    // 提出回数の検索欄がない画面（共通コントローラーを利用）では絞り込まない
    if (!this.hasNumberingFromTarget || !this.hasNumberingToTarget) {
      return rowTargets;
    }

    const from = this.numberingFromTarget.value;
    const to = this.numberingToTarget.value;

    if (from === "" && to === "") {
      return rowTargets;
    }

    return rowTargets.filter(row => {
      const numbering = Number(row.dataset.numbering);
      if (from !== "" && numbering < Number(from)) return false;
      if (to !== "" && numbering > Number(to)) return false;
      return true;
    });
  }

  changeCorrectionStatusCounts() {
    const filteredRows = this.filterMediaTestMarker(this.rowTargets);

    this.correctionTotalCountTarget.textContent = filteredRows.length;

    const notScoredCount = filteredRows.filter(row => row.dataset.evaluationStatus === 'not_scored').length;
    this.notScoredCountTarget.textContent = notScoredCount
    this.notScoredCountParentTarget.classList.toggle('count-post-it-label--warn', notScoredCount > 0);

    const notEvaluatedCount = filteredRows.filter(row => row.dataset.evaluationStatus === 'not_evaluated').length;
    this.notEvaluatedCountTarget.textContent = notEvaluatedCount
    this.notEvaluatedCountParentTarget.classList.toggle('count-post-it-label--warn', notEvaluatedCount > 0)
  }

  changeFinalScoreGradeCounts() {
    this.finalScoreGradeTargets.forEach(finalScoreGrade => {
      const finalScoreGradeCount = this.rowTargets.filter(row => row.dataset.finalScoreGrade === finalScoreGrade.dataset.finalScoreGrade).length;
      finalScoreGrade.querySelector('[data-counter-text]').textContent = finalScoreGradeCount;
    });
  }

  disableEvaluatesButton() {
    const teacherRows = this.filterLoginTeacherRows();

    if (this.isMediaTestMarkerValue && this.isCourseSubmissionEndDatePastValue && this.areAllNotEvaluated(teacherRows)) {
      this.evaluatesButtonTarget.disabled = false;
    } else {
      this.evaluatesButtonTarget.disabled = true;
    }
  }

  filterLoginTeacherRows() {
    return this.rowTargets.filter(row => row.dataset.isLoginTeacherCorrection === '');
  }

  areAllNotEvaluated(rows) {
    return rows.length > 0 && rows.every(row => row.dataset.evaluationStatus === 'not_evaluated');
  }
}
